import { useSelector } from "react-redux";

import SiteTitle from "./../../../helpers/SiteTitle/SiteTitle";
import { servicesData } from "../../../utils/data";
import { base_url } from "../../../services/configServices/config";

const ServicesPublic = () => {
  const image = useSelector((state) => state.meta?.image);
  const setting = useSelector((state) => state.meta?.setting);

  return (
    <>
      <SiteTitle title="خدمات" />
      {/* Section Started Inner */}
      <section className="section kf-started-inner">
        <div
          className="kf-parallax-bg"
          style={{ backgroundImage: `url(${base_url + image?.serviceBanner})` }}
        />
        <div className="container">
          <h1
            className="kf-h-title text-anim-1 scroll-animate align-center"
            data-animate="active"
          >
            خدمات {setting?.title}
          </h1>
        </div>
      </section>
      {/* Section Services */}
      <section className="section kf-services">
        <div className="container">
          <div className="kf-titles align-center">
            <div
              className="kf-subtitle element-anim-1 scroll-animate"
              data-animate="active"
            >
              خدمات ما
            </div>
            <h3
              className="kf-title element-anim-1 scroll-animate"
              data-animate="active"
            >
              برخی خدمات {setting?.title}
            </h3>
          </div>
          <div className="kf-services-items row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4">
              <div
                className="kf-services-item element-anim-1 scroll-animate"
                data-animate="active"
              >
                <div className="image kf-image-hover">
                  <img src="/assets/images/service1.jpg" alt="image" />
                </div>
                <div className="desc">
                  <div className="icon">
                    <i className="las la-utensils" />
                  </div>
                  <h5 className="name">فست فود</h5>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4">
              <div
                className="kf-services-item element-anim-1 scroll-animate"
                data-animate="active"
              >
                <div className="image kf-image-hover">
                  <img src="/assets/images/service2.jpg" alt="image" />
                </div>
                <div className="desc">
                  <div className="icon">
                    <i className="las la-coffee" />
                  </div>
                  <h5 className="name">صبحانه</h5>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4">
              <div
                className="kf-services-item element-anim-1 scroll-animate"
                data-animate="active"
              >
                <div className="image kf-image-hover">
                  <img src="/assets/images/service3.jpg" alt="image" />
                </div>
                <div className="desc">
                  <div className="icon">
                    <i className="las la-glass-cheers" />
                  </div>
                  <h5 className="name">نوشیدنی</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Section Numbers-2 */}
      <section className="section kf-numbers-2 section-bg">
        <div className="container">
          <div className="kf-titles align-center">
            <div
              className="kf-subtitle element-anim-1 scroll-animate"
              data-animate="active"
            >
              تنوع {setting?.title}
            </div>
            <h3
              className="kf-title element-anim-1 scroll-animate"
              data-animate="active"
            >
              تنوع منو {setting?.title}
            </h3>
          </div>
          <div className="kf-numbers-items-2 row">
            {servicesData?.map((_item, index) => (
              <div
                key={index}
                className="col-xs-12 col-sm-12 col-md-4 col-lg-3"
              >
                <div
                  className="kf-numbers-item-2 element-anim-1 scroll-animate d-flex flex-column justify-content-center align-items-center"
                  data-animate="active"
                >
                  <div className="icon">
                    <i className={_item.icon} />
                  </div>
                  <div className="desc">
                    <h5 className="name">{_item.title}</h5>
                    {_item.description && (
                      <div className="subname">{_item.description}</div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Section Services-2 */}
      <section className="section kf-services">
        <div className="container">
          <div className="kf-services-items-2 row">
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3">
              <div
                className="kf-services-item-2 element-anim-1 scroll-animate"
                data-animate="active"
              >
                <div className="image">
                  <img src="/assets/images/service_icon1.png" alt="image" />
                </div>
                <div className="desc">
                  <h5 className="name">جشن تولد</h5>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3">
              <div
                className="kf-services-item-2 element-anim-1 scroll-animate"
                data-animate="active"
              >
                <div className="image">
                  <img src="/assets/images/service_icon2.png" alt="image" />
                </div>
                <div className="desc">
                  <h5 className="name">غذای تازه</h5>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3">
              <div
                className="kf-services-item-2 element-anim-1 scroll-animate"
                data-animate="active"
              >
                <div className="image">
                  <img src="/assets/images/service_icon3.png" alt="image" />
                </div>
                <div className="desc">
                  <h5 className="name">مواد غذایی مرغوب</h5>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3">
              <div
                className="kf-services-item-2 element-anim-1 scroll-animate"
                data-animate="active"
              >
                <div className="image">
                  <img src="/assets/images/service_icon4.png" alt="image" />
                </div>
                <div className="desc">
                  <h5 className="name">آبمیوه طبیعی</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ServicesPublic;
